module.exports = __webpack_public_path__ + "img/Hunter-draenei-f-70.4597a1a4.gif";